<kodit-page [showCardBlock]="false">
  <kodit-table [tableConfig]="tableConfig" [items]="stavkeCenovnika">
  </kodit-table>
</kodit-page>
